export const MenuConsumer = "MenuConsumer";
